<template>
  <div>
    <v-dialog persistent v-model="dialog" max-width="950" scrollable>
      <v-card class="filter-card">
        <v-card-title class="filter-header">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="white">mdi-filter-variant</v-icon>
            <span class="headline font-weight-bold white--text">DOTS Filter</span>
          </div>
          <v-btn
            @click="cancel"
            class="white--text close-header-btn"
            icon
            large
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="filter-section mb-6">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-account-search</v-icon>
              <span class="subtitle-1 font-weight-bold">Search by Name</span>
            </div>
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-text-field
                  v-model.trim="name"
                  placeholder="Enter patient name..."
                  outlined
                  prepend-inner-icon="mdi-account"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="text-md-right">
                <v-btn
                  @click="searchByName"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="!name"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <div class="filter-section mb-6">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-progress-check</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by Status</span>
            </div>
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-select
                  v-model="current_status"
                  :items="statusOptions"
                  item-text="text"
                  item-value="value"
                  placeholder="Select status"
                  outlined
                  prepend-inner-icon="mdi-format-list-bulleted"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  @click="searchByStatus"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="current_status === null || current_status === ''"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <div class="filter-section mb-6">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-cellphone</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by App User</span>
            </div>
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-select
                  v-model="dots_app_status"
                  :items="appUserOptions"
                  item-text="text"
                  item-value="value"
                  placeholder="Select app user type"
                  outlined
                  prepend-inner-icon="mdi-format-list-bulleted"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  @click="searchByAppUser"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="dots_app_status === null || dots_app_status === ''"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <div class="filter-section mb-6">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-file-document-check</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by Reported</span>
            </div>
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-select
                  v-model="reported_status"
                  :items="reportedOptions"
                  item-text="text"
                  item-value="value"
                  placeholder="Reported this month"
                  outlined
                  prepend-inner-icon="mdi-format-list-bulleted"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  @click="searchByReported"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="reported_status === null || reported_status === ''"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="my-6"></v-divider>

          <div class="filter-section">
            <div class="section-title mb-4">
              <v-icon class="mr-2" color="#aa00ff">mdi-calendar-start</v-icon>
              <span class="subtitle-1 font-weight-bold">Filter by DOT Start Date</span>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  :items="months"
                  v-model="month"
                  item-text="text"
                  item-value="value"
                  placeholder="Select Month"
                  outlined
                  prepend-inner-icon="mdi-calendar-month"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="years"
                  v-model="year"
                  item-text="text"
                  item-value="value"
                  placeholder="Select Year"
                  outlined
                  prepend-inner-icon="mdi-calendar"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  @click="searchByStartDate"
                  class="search-btn-purple"
                  large
                  block
                  :disabled="!month || !year"
                  dark
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-btn
            @click="clearAllFilters"
            text
            color="grey darken-1"
            class="mr-2"
          >
            <v-icon left small>mdi-filter-off</v-icon>
            Clear All
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="cancel"
            outlined
            color="grey darken-1"
            class="mr-2"
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
    },
  },
  data: () => ({
    name: "",
    current_status: null,
    dots_app_status: null,
    reported_status: null,
    month: null,
    year: null,
    statusOptions: [
      { value: 1, text: "Stop" },
      { value: 2, text: "On-going" },
      { value: 0, text: "Default" },
    ],
    appUserOptions: [
      { value: 2, text: "App User" },
      { value: 1, text: "No App User" },
    ],
    reportedOptions: [
      { value: 2, text: "Yes" },
      { value: 1, text: "No" },
    ],
  }),
  computed: {
    ...mapState("InitialData", ["months", "years"]),
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    closeAfterSearch() {
      this.$emit("cancel");
    },
    searchByName() {
      if (!this.name) return;
      this.$router.push({
        path: "/dots",
        query: { name: this.name, page: 1 },
      });
      this.closeAfterSearch();
    },
    searchByStatus() {
      if (this.current_status === null || this.current_status === "") return;
      this.$router.push({
        path: "/dots",
        query: { current_status: this.current_status, page: 1 },
      });
      this.closeAfterSearch();
    },
    searchByAppUser() {
      if (this.dots_app_status === null || this.dots_app_status === "") return;
      this.$router.push({
        path: "/dots",
        query: { dots_app_status: this.dots_app_status, page: 1 },
      });
      this.closeAfterSearch();
    },
    searchByReported() {
      if (this.reported_status === null || this.reported_status === "") return;
      this.$router.push({
        path: "/dots",
        query: { reported_status: this.reported_status, page: 1 },
      });
      this.closeAfterSearch();
    },
    searchByStartDate() {
      if (!this.month || !this.year) return;
      this.$router.push({
        path: "/dots",
        query: { month: this.month, year: this.year, page: 1 },
      });
      this.closeAfterSearch();
    },
    clearAllFilters() {
      this.name = "";
      this.current_status = null;
      this.dots_app_status = null;
      this.reported_status = null;
      this.month = null;
      this.year = null;
    },
  },
};
</script>

<style scoped>
.filter-card {
  border-radius: 12px;
  overflow: hidden;
}

.filter-header {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%);
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.2);
}

.close-header-btn {
  transition: all 0.3s ease;
}

.close-header-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  transform: rotate(90deg);
}

.section-title {
  display: flex;
  align-items: center;
  color: #424242;
  margin-bottom: 16px;
}

.section-title .v-icon {
  font-size: 24px;
}

.v-select,
.v-text-field {
  border-radius: 6px;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-btn:not(.v-btn--disabled) {
  transition: all 0.3s ease;
}

.v-btn:not(.v-btn--disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.3);
}

.search-btn-purple {
  background: linear-gradient(135deg, #aa00ff 0%, #8e00cc 100%) !important;
  color: white !important;
  box-shadow: 0 2px 8px rgba(170, 0, 255, 0.3) !important;
}

.search-btn-purple:hover:not(.v-btn--disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(170, 0, 255, 0.4) !important;
}

.v-card-actions {
  background-color: #fafafa;
}

@media (max-width: 960px) {
  .filter-section {
    margin-bottom: 24px;
  }

  .v-btn {
    margin-top: 8px;
  }
}
</style>
